import ActionFooter from '../components/ActionFooter';
import type { IQuickView, QuickViewDefaultFooterComponents } from '../shared/types';

export default function useDefaultFooterComponents(quickViewProps: IQuickView): QuickViewDefaultFooterComponents {
    const { onClose } = quickViewProps;

    return {
        ActionFooter: (props) => <ActionFooter onClick={onClose} {...props} />
    };
}
